import * as React from 'react'

// Served from `public/` as a static asset (URL string), like the other SVGs in
// this codebase. Avoids bundler-specific SVG import config (was the only
// `import x from './x.svg'` in the app, which forced webpack's asset/resource
// rule; moving it lets the build run on Turbopack with no SVG config).
const svg = '/illustrations/community.svg'

export const CommunityIcon = ({
  width,
  height,
}: {
  width: number
  height: number
}) => {
  return <img src={svg} alt="Community" width={width} height={height} />
}
